module.exports = __webpack_public_path__ + "img/DirtyLensOutlined.c687a276.svg";